module.exports = __webpack_public_path__ + "static/img/img04.49567a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/market/freetarget/img04.png
// module id = lVVD
// module chunks = 1